"use strict";
var globalThis = require("../internals/global-this");
var isObject = require("../internals/is-object");
var document = globalThis.document;
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
  return EXISTS ? document.createElement(it) : {};
};
